import React from 'react';

import { Stack } from '@gogame/components';

import FilterDetailsItem from './FilterDetailsItem';

const FilterDetails = ({ filters, getFilterTitle }) => {
  return (
    <Stack spacing={0.5}>
      {filters
        ? Object.keys(filters)
            .filter((key) => filters[key])
            .map((key, i, arr) => {
              const value = filters[key];

              if (!value) {
                return null;
              }

              return (
                <FilterDetailsItem
                  key={key}
                  label={getFilterTitle(key) || key}
                  value={value}
                  lastItem={i === arr.length - 1}
                />
              );
            })
        : null}
    </Stack>
  );
};

export default FilterDetails;
